export const STORAGE_KEYS = {
  USER: 'user',
  DEVICE_ID: 'device_unique_id'
}
